import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('DocumentModelDto', DocumentModelDataDto);

    DocumentModelDataDto.$inject = ['DocumentModel'];

    /* @ngInject */
    function DocumentModelDataDto(DocumentModel) {
        DocumentModelDto.prototype = {
            build: build,
            buildEmpty: buildEmpty
        };

        function DocumentModelDto(documentModelData) {
            if (!documentModelData) {
                this.buildEmpty();
            } else {
                this.build(documentModelData);
            }
        }

        return DocumentModelDto;

        /////////////////////

        function buildEmpty() {
            this.specific = false;
            this.documentModelEnable = false;
            this.documentModelUpdateEnable = false;
            this.reAddLine = false;
            this.reReliquant = false;
            this.document = null;
        }

        function build(documentModelData) {
            this.specific = documentModelData.specific || false;
            this.documentModelEnable = documentModelData.documentModelEnable || false;
            this.documentModelUpdateEnable = documentModelData.documentModelUpdateEnable || false;
            this.reReliquant = documentModelData.reReliquant || false;
            this.reAddLine = documentModelData.reAddLine || false;
            this.documentModel = new DocumentModel(documentModelData.documentModel);
            this.missingAttributes = documentModelData.missingAttributes;
        }

    }
})();
